/**
 * detekce světlosti barvy elementu dle ITU-R BT.709
 * @param elem HTMLElement element, jehož světlost se detekuje
 * @param prop string vlastnost elementu obsahující barvu (výchozí background-color)
 * @return int ;0 = nejtmavší, 255 = nejsvětlejší, 128 = práh tmavosti
 */
FN.getLuma = (elem, prop, _) =>
    (_ = FN.getCSSVar(elem, prop||"background-color").replace(/[^0-9,]/g,'').split(","))
    && (0.2126 * _[0] + 0.7152 * _[1] + 0.0722 * _[2]);

FN.getCSSVar = (element, varName) => getComputedStyle(element).getPropertyValue(varName).trim();
FN.uncheckInputs = selector => document.querySelectorAll(selector).forEach(input => input.checked = false);

// vlastní chybové elementy  LiveForm
LiveForm.getMessageId = el => el.id + LiveForm.options.messageIdPostfix; // nepokoušej se vymýšlet unikátní ID: pokud je element v šabloně, použij ten
LiveForm.options.messageErrorClass = "error"; // bohužel nejde nastavit, aby se zprávám nepřepisovala třída javascriptem; ignoruj messageErrorPrefix
LiveForm.options.messageErrorPrefix = ""; // LFV jako výchozí vnucuje vlastní prefix
LiveForm.processServerErrors = _=>_; // nepokoušej se odstraňovat chybové elementy

// po výběru radiobutton skryj chybovou zprávu
LiveForm.setupRadio = el => (el.type=="radio" || el.type=="checkbox") && el.addEventListener("change", _=>
    !el.name.includes("[") &&
    document.querySelectorAll(`[id*=-${el.name}-][id*=_message]`).forEach(msgEl => msgEl.innerHTML = "")
);
LiveForm._setupHandlers = LiveForm.setupHandlers;
LiveForm.setupHandlers = el => LiveForm.setupRadio(el) || LiveForm._setupHandlers(el);

// Přidání stínu při scrollování pod hlavičku
document.addEventListener("DOMContentLoaded", function() {
    const headerMenu = document.querySelector('.headerMenu');
    const burgerIcon = document.getElementById('burgerIcon');

    if (!headerMenu) {
        return;
    }
        
    function handleScroll() {
        headerMenu.classList.toggle('is-sticky', window.scrollY > 40);
    }
        
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    if (burgerIcon) {
        const toggleMobileMenu = () => headerMenu.classList.toggle('menu-open', burgerIcon.checked);
        burgerIcon.addEventListener('change', toggleMobileMenu);
        toggleMobileMenu();
    }
});